import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "./apiTypes";
import { unwrapData, unwrapList } from "./apiTypes";

export type AdminSupportAttachment = {
  id: number;
  name: string;
  mime?: string | null;
  size: number;
  url?: string | null;
};

export type AdminSupportRequest = {
  id: number;
  name: string;
  phone: string;
  problem: string;
  source?: string | null;
  status: "pending" | "in_progress" | "resolved" | "closed" | string;
  admin_note?: string | null;
  reviewed_at?: string | null;
  created_at?: string | null;
  reviewer?: { id: number; name?: string | null } | null;
  attachments?: AdminSupportAttachment[];
};


export type AdminSupportContactSettings = {
  button_label_ar: string;
  button_label_en: string;
  button_subtitle_ar: string;
  button_subtitle_en: string;
  name_label_ar: string;
  name_label_en: string;
  name_placeholder_ar: string;
  name_placeholder_en: string;
  phone_label_ar: string;
  phone_label_en: string;
  phone_placeholder_ar: string;
  phone_placeholder_en: string;
  problem_label_ar: string;
  problem_label_en: string;
  problem_placeholder_ar: string;
  problem_placeholder_en: string;
  attachments_label_ar: string;
  attachments_label_en: string;
  attachments_button_ar: string;
  attachments_button_en: string;
  submit_label_ar: string;
  submit_label_en: string;
  sending_label_ar: string;
  sending_label_en: string;
};
export type AdminSupportRequestsQuery = {
  page?: number;
  limit?: number;
  term?: string;
  status?: string;
};

export const adminSupportRequestsService = {
  async list(params: AdminSupportRequestsQuery = {}) {
    const response = await api.get<ApiEnvelope<PaginatedResult<AdminSupportRequest>>>(
      "/mcp/support-requests",
      { params, meta: { toastSuccess: false } }
    );
    return unwrapList(response.data);
  },

  async getSettings(): Promise<AdminSupportContactSettings> {
    const response = await api.get<ApiEnvelope<{ data: AdminSupportContactSettings }>>(
      "/mcp/support-settings",
      { meta: { toastSuccess: false } }
    );
    return unwrapData(response.data)!;
  },

  async updateSettings(
    payload: Partial<AdminSupportContactSettings>
  ): Promise<AdminSupportContactSettings> {
    const response = await api.put<ApiEnvelope<{ data: AdminSupportContactSettings }>>(
      "/mcp/support-settings",
      payload
    );
    return unwrapData(response.data)!;
  },

  async show(id: number) {
    const response = await api.get<ApiEnvelope<AdminSupportRequest>>(
      `/mcp/support-requests/${id}`,
      { meta: { toastSuccess: false } }
    );
    return response.data.result;
  },

  async update(id: number, payload: { status: string; admin_note?: string | null }) {
    return api.patch<ApiEnvelope<AdminSupportRequest>>(
      `/mcp/support-requests/${id}`,
      payload,
      { meta: { toastError: false } }
    );
  },
};
